module.exports = __webpack_public_path__ + "static/me-estoy-pareciendo-a-ti_acrylic-on-canvas-36x24in-51c545729b361c659fa2359175bdb4af.jpg";